export type TRiskStatus = "open" | "addressed";
export type TRiskSource = "generated" | "manual";
export type TRiskFileSection = "plan" | "results";
export type TScoreLevel = "low" | "medium" | "high";

export type TRiskFile = {
  id: number;
  section: TRiskFileSection;
  fileName: string;
  fileSize: number;
};

export type TRisk = {
  id: number;
  title: string;
  whatMustHoldTrue: string;
  whyItMatters: string;
  impact: number;
  uncertainty: number;
  status: TRiskStatus;
  source: TRiskSource;
  plan: string | null;
  results: string | null;
  addressedAt: string | null;
  sortOrder: number;
  files: TRiskFile[];
};

export type TRiskInput = {
  title: string;
  whatMustHoldTrue: string;
  whyItMatters: string;
  impact: number;
  uncertainty: number;
};

export const SCORE_LEVEL_LABEL_KEY = {
  low: "risks.level.low",
  medium: "risks.level.medium",
  high: "risks.level.high"
} as const;

export const scoreLevel = (score: number): TScoreLevel => {
  if (score <= 3) return "low";
  if (score <= 7) return "medium";
  return "high";
};

// The one or two beliefs the whole case turns on: open risks high on both axes, worst first.
export const pickCrux = (risks: TRisk[]): Set<number> => {
  const ranked = risks
    .filter((risk) => risk.status === "open" && risk.impact >= 6 && risk.uncertainty >= 6)
    .sort((a, b) => b.impact * b.uncertainty - a.impact * a.uncertainty)
    .slice(0, 2);
  return new Set(ranked.map((risk) => risk.id));
};
